



































import { Component, Mixins } from 'vue-property-decorator'
import { TCWBaseError } from '@/plugins/TCWBaseError'
import * as ApiPath from '@/tcw/constant/ApiPath'
import BasePage from '@/tcw/components/BasePage'
import DataUpdateComponent from '@/tcw/components/DataUpdateComponent'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import ToiawaseInputForm from '@/components/help/organisms/ToiawaseInputForm.vue'

@Component({
  components: { TcwLayoutBasicTemplate, ToiawaseInputForm }
})
export default class ErrorInfo extends Mixins(BasePage, DataUpdateComponent) {
  private title = 'エラーが発生しました'
  private isViewSubmitDialog = false

  get apiPath(): string {
    return ApiPath.Paths.Toiawase.post
  }

  private form = {
    title: this.errorMessage,
    shubetsu: '1',
    naiyou: this.sousinStack,
    file: '',
    kinkyudo: 3
  }

  get error(): TCWBaseError | null {
    return this.$tcw.$store.errors.get
  }

  get errorMessage(): string {
    return this.error?.outputMessage ? this.error.outputMessage() : 'エラーが発生しました'
  }

  get stack(): string {
    return this.error && this.error.stack ? this.error.stack : ''
  }

  get sousinStack(): string {
    return `※例外が発生した状況や操作手順を分かる範囲でご記入ください。
    
    ※以下はエラースタックなので、削除しないでください
    ${this.stack}`
  }

  private clear(): void {
    this.$tcw.$store.errors.clear()
  }
  private goTop(): void {
    this.$tcw.$store.errors.clear()
    this.$router.push('/')
  }

  private submit(): void {
    this.isViewSubmitDialog = true
  }

  protected async confirmSubmit(): Promise<void> {
    const confirm = await this.$tcw.confirm({ type: 'warning', message: '送信して良いですか？' })
    if (confirm) {
      this.startSaveProc()
    }
  }

  protected async execSaveMain(): Promise<void> {
    // パスワード更新処理を実行
    await this.getWebApi().call(this.apiPath, 'POST', this.form)
  }
  protected async afterSaveProc(): Promise<void> {
    this.$tcw.message({
      type: 'success',
      message: '問い合わせを送信しました'
    })
    // 前画面に戻る
    this.isViewSubmitDialog = false
    this.$tcw.error.clear()
  }
}
